/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ uptime: NonNullable<unknown> }} System_Status_UptimeInputs */



/**
* | output |
* | --- |
* | "{uptime}% uptime (90d)" |
*
* @param {System_Status_UptimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_uptime = /** @type {((inputs: System_Status_UptimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_UptimeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.uptime}% Verfügbarkeit (90 T.)`)
	return /** @type {LocalizedString} */ (`${i?.uptime}% uptime (90d)`)
});